import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3597df5f&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"
import style0 from "./Index.vue?vue&type=style&index=0&id=3597df5f&prod&lang=scss&"
import style1 from "./Index.vue?vue&type=style&index=1&id=3597df5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597df5f",
  null
  
)

export default component.exports